import { mapGetters, mapActions } from "vuex";
import querystring from 'querystring'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters('indice', ['getIndiceRanking']),
    ...mapGetters('fund', ['getFundFilter']),
    ...mapGetters('stock', ['getStockFilter']),
  },
  methods: {
    ...mapActions("indice", ["findIndiceRanking", "findIndicePrice"]),
    ...mapActions("fund", ["findFundFilter"]),
    ...mapActions("stock", ["findStockFilter"]),

    async mixins_global_getIndiceFilter(condition = {}) {
      await this.findIndiceRanking(condition.period)
    },

    async mixins_global_getFundFilter(condition = {}) {
      let parseCondition = querystring.stringify(condition)
      await this.findFundFilter(parseCondition);
    },

    async mixins_global_getStockFilter(condition = {}) {
      Object.keys(condition).length === 0 ? condition = { period: "1Y", limit: 30 } : null // set default query
      let parseCondition = querystring.stringify(condition)
      await this.findStockFilter({ payload: parseCondition, period: condition.period });
    },
  },
}